import { CourseList, TAcademyCourse, Typography } from "@cpj-ai/panel-npm-package";
import { useGetEmployeeCoursesQuery } from "@graphql/generated";
import { Spinner } from "@heroui/react";
import { useMemo } from "react";

interface TrainingTabContentProps {
  employeeId?: string;
}

export default function TrainingTabContent({ employeeId }: TrainingTabContentProps) {
  const { data, loading } = useGetEmployeeCoursesQuery({ variables: { id: employeeId ?? "" } });

  const courses = useMemo(
    () =>
      (data?.organization?.employee?.get?.employee?.courses?.edges ?? [])
        .map((edge) => edge?.node)
        .filter((course): course is TAcademyCourse => Boolean(course)),
    [data],
  );

  const accumulatedCourses = useMemo(() => {
    const completedCourses: TAcademyCourse[] = [];
    const notCompletedCourses: TAcademyCourse[] = [];

    courses.forEach((course) => {
      if (course) {
        if (course.results?.edges?.length) {
          completedCourses.push(course);
        } else {
          notCompletedCourses.push(course);
        }
      }
    });

    return { completedCourses, notCompletedCourses };
  }, [courses]);

  const examCardProps: React.ComponentProps<typeof CourseList>["sliderProps"] = {
    cardProps: {
      className: "border border-gray-300",
      isClickable: false,
    },
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-full">
        <Spinner />
      </div>
    );
  }

  return (
    <div>
      {!!accumulatedCourses.completedCourses.length && (
        <CourseList
          title="complate courses:"
          courses={accumulatedCourses.completedCourses}
          sliderProps={examCardProps}
        />
      )}
      <div className="h-4" />
      {!!accumulatedCourses.notCompletedCourses.length && (
        <CourseList
          title="suggested courses:"
          courses={accumulatedCourses.notCompletedCourses}
          sliderProps={examCardProps}
        />
      )}
      {!courses.length && (
        <div className="w-full h-full flex justify-center items-center">
          <Typography className="text-small">There are no courses</Typography>
        </div>
      )}
    </div>
  );
}
